import Configurator from "../../config/Configurator";
import axios from "axios";

export const postApi = async (endpoint, payload, objectKey) => {
  try {
    const url = (await Configurator()).API_URL + "/v2/io/" + endpoint;
    const config = {
      method: "post",
      url,
      headers: {
        ...axios.defaults.headers.common,
        Session: localStorage.getItem("apiKey"),
        "User-Id": localStorage.getItem("userID"),
        "Content-Type": "application/json",
      },
      data: { data: payload },
    };
    const res = await axios.request(config);

    return objectKey ? res.data?.data?.[objectKey] : res.data;
  } catch (error) {
    console.error(`POST ${endpoint} failed:`, error);
    return null;
  }
};
